import { useState, useEffect, useCallback, Fragment } from "react";
import { Col, Row } from "react-flexbox-grid";
import CancelIcon from "@material-ui/icons/Cancel";
import Divider from "@material-ui/core/Divider";

import AvatarMaterial from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import styled from "styled-components";

const WrapperAvatar = styled.div`
  padding: 8px;

  .MuiSvgIcon-root {
    width: 22px;
    height: 22px;
    position: absolute;
    padding: 0;
    z-index: 9;
    margin: 0.4em 0 0 2.8em;
    cursor: pointer;
    background: #fff;
    border-radius: 100%;
    padding: 2px;
  }
`;

const LargeAvatar = styled(AvatarMaterial)`
  width: 94px !important;
  height: 94px !important;
  padding: 4px;
`;

export const UploadList = ({
  defaultValue = [],
  value = [],
  onChange = () => null,
  onRemove,
  accept = ".png, .jpg, .jpeg, .webp",
  text,
}) => {
  const [file, setFile] = useState([]);

  const onUploadFile = async (e) => {
    const currentFile = e.target.files;

    Object.keys(currentFile).map((item) => {
      currentFile[item].originFileObj = URL.createObjectURL(currentFile[item]);
      return item;
    });

    const fileList = [...file, ...e.target.files];

    setFile(fileList);
    onChange(fileList);
  };

  const getInitialState = useCallback(() => {
    Array.isArray(defaultValue) && setFile(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    getInitialState(); // initial state
  }, []);

  // console.log(file);

  return (
    <>
      <Col md={12}>
        <input
          accept={accept}
          id="contained-button-file"
          className="dn"
          onChange={onUploadFile}
          multiple
          type="file"
        />

        <label htmlFor="contained-button-file">
          <Button color="secondary" component="span">
            {text}
          </Button>
        </label>
      </Col>
      <PreviewImages
        onRemove={onRemove}
        defaultValue={defaultValue}
        value={value}
      />
    </>
  );
};

const PreviewImages = ({ defaultValue, value, onRemove = () => null }) => {
  return (
    <Col md={12}>
      <Row>
        {value.map(({ name, originFileObj, ...rest }) => (
          <WrapperAvatar key={name} md={3}>
            <CancelIcon onClick={() => onRemove({ name, ...rest })} />
            <LargeAvatar variant="square" alt={name} src={originFileObj} />
          </WrapperAvatar>
        ))}
      </Row>
      {defaultValue.length > 0 && <Divider />}
      <Row>
        {defaultValue.map((image) => (
          <WrapperAvatar key={image} md={3}>
            <CancelIcon onClick={() => onRemove(image)} />
            <LargeAvatar variant="square" alt={image} src={image} />
          </WrapperAvatar>
        ))}
      </Row>
    </Col>
  );
};
